<div class="record-card-grid">
  <ng-content></ng-content>
</div>
